module.exports = __webpack_public_path__ + "img/insurance-needs.f3c9b3aa.svg";